import React, { ReactNode } from 'react'
import { InfoBannerParagraph, InfoBannerWrapper } from './info-banner.styles'

interface IInfoBanner {
    paragraphs: ReadonlyArray<string> | undefined
    disabled?: boolean
    children?: ReactNode
}

export const InfoBanner = ({ paragraphs, disabled, children }: IInfoBanner) => {
    if (paragraphs === undefined || paragraphs.length === 0) {
        return null
    } else {
        return (
            <InfoBannerWrapper as="div" $disabled={disabled}>
                {paragraphs.map((paragraph, index) => (
                    <InfoBannerParagraph key={index}>{paragraph}</InfoBannerParagraph>
                ))}
                {children}
            </InfoBannerWrapper>
        )
    }
}
